export default {
  release: '16.1',
  date: 'June 2023',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-1-released/#this-months-notable-contributor',
  contributors: [
    {
      name: 'Gerardo Navarro',
      gitlabUsername: 'gerardo-navarro',
    },
    {
      name: 'Yuri Konotopov',
      gitlabUsername: 'nE0sIghT',
    },
  ],
  writeUp: `Gerardo has been consistently iterating over multiple releases to deliver
the [REST API endpoints for job token scope](https://gitlab.com/gitlab-org/gitlab/-/issues/351740).
Iteration is one of our [core values](https://handbook.gitlab.com/handbook/values/#iteration) 
at GitLab, and Gerardo has exemplified that with his multiple contributions to deliver the feature.

Due to the change in [default \`CI_JOB_TOKEN\` behavior](https://docs.gitlab.com/ee/update/deprecations.html#default-cicd-job-token-ci_job_token-scope-changed), 
users who automate creation of projects cannot also automate adding the projects allowed to use 
a \`CI_JOB_TOKEN\` with the project. This REST API endpoint enables our customers to automate this 
process again and drive increased adoption of a more secure \`CI_JOB_TOKEN\` workflow.

Thanks to Gerardo and the rest of the crew from Siemens!

Yuri picked up an [issue](https://gitlab.com/gitlab-org/gitlab/-/issues/18287) that 
was logged 6 years ago, took a [bias for action](https://handbook.gitlab.com/handbook/values/#bias-for-action) 
(one of our GitLab values) and contributed a fix.

This was a popular feature that a number of customers were interested in. This enhancement 
allows the system admin to skip specific projects during backup and restore, based on a comma-separated list of group 
or project paths. With this feature, system admins can skip over stale 
or archived projects during their backup run, save storage space and speed up the backup. 
They can also exclude specific projects when restoring from backup using the same option.

Thanks to Yuri for his valuable contribution!`,
};
